"use client";

import Image from "next/image";
import { SECTION_CONFIG } from "@/views/about/constants";
import { Container } from "@/components/ui/container";
import S from "../index.module.scss";
import { useAboutData } from "@/views/about/hooks/useAboutData";
import { useMedia } from "@/hooks/system/useMedia";

// TODO: перенести стили для блоков в админку

const Section = () => {
  const { isClient } = useMedia();
  const { data } = useAboutData();

  return (
    <>
      {data?.sections.map((item, idx) => (
        <Container className={S.wrapper} key={idx}>
          <Image className={S.image} src={item.background} width={1600} height={900} alt={item.title ?? ""} />

          <div className={S.content} style={SECTION_CONFIG[idx] ?? SECTION_CONFIG[0]}>
            <div className={S.textWrapper}>
              <h2 className={S.title}>{item.title}</h2>
              {item.description && isClient && (
                <p className={S.description} dangerouslySetInnerHTML={{ __html: item.description }} />
              )}
              {!!item.companies.length && (
                <div className={S.companies}>
                  {item.companies.map(company => (
                    <Image
                      width={120}
                      height={40}
                      key={company}
                      src={company}
                      alt={company}
                      className={S.companyImage}
                    />
                  ))}
                </div>
              )}
            </div>
          </div>
        </Container>
      ))}
    </>
  );
};

export default Section;
